<template>
    <div>
        <!-- 轮播图 -->
        <!-- <img src="@/assets/img/banner.jpg" style="width: 100%;" alt=""> -->
        <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :src="item.img" style="width: 100%;">
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
      </div>
    </div>
        <!-- 关于我们 -->
        <div class="">
            <div class="">
                <div class="flex-column align-center justify-center header1">
                    <div class="title">
                        About us
                    </div>
                    <!-- <div class="sub_title">About us</div> -->
                </div>
                <div class="w">
                    <div class="content flex-row justify-between" style="height: 300px;">
                        <div class="content-left basis-df" >
                        <video src="@/assets/video-en.mp4" controls  style="width: 95%; height: auto;"></video>

                        </div>
                        <div class="content-right basis-df flex-column justify-between" style="margin-left: 20px;">
                            <div style="text-indent: 2rpx;">
                                <div style="text-indent: 2rem;line-height: 30px;">FJ Controlling Co., Ltd. is a national high-tech enterprise dedicated to the research &amp; development, manufacture and sale of products such as PMS motors and controllers, and smart displays. Equipped with over 350 employees, more than 92 patents, and over 8000 square meters of production space, we provide an annual capacity over 700K units.
Since the establishment in 2011, we have been insisting on serving customers with independent core technology. The series of products independently developed and produced including electric vehicle controllers, smart displays, remote monitoring and management system, etc., have been successfully applied in the fields of electric forklifts, electric storage vehicles, electric sightseeing vehicles, golf carts, sanitation vehicles, aerial work platforms, construction machinery, agriculture, gardening and ships. FJ controlling’s customers cover leading enterprises in the industrial vehicles such as Heli Group, Lonking, Linde, Tailift, etc., we strive to become a world-class interprise and to contribute to promoting the popularity of global electrification.
</div>
                                 <!-- <div style="text-indent: 2rem;line-height: 30px;">Since its establishment in 2011, the company has always focused on the research and development of electronic control compo-
nents, insisting on serving customers with independent core technology. The series of products independently developed and produced
include electric vehicle controller, smart display, remote monitoring and management systems, etc., which have been successfully
applied in the fields of electric forklifts, electric storage vehicles, electric sightseeing vehicles, golf carts, sanitation vehicles, aerial work
platforms, construction machinery, agriculture, gardening, and ships. Customers cover leading enterprises in the whole vehicle industry
such as Terex, Zoomlion, BYD Forklift, Heli Group, Lonking, XCMG Group, etc., providing one-stop solutions for electric control,
intelligence, and internet connection for off-road vehicle enterprises</div> -->
                            </div>
                            <div class="flex-row justify-end">
                                <div class="more" @click="page('about')">
                                    >> More
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 产品中心 -->
        <div class="">
            <div class="w">
                <div class="flex-column align-center justify-center header1">
                    <div class="title">
                        Products
                    </div>
                    <!-- <div class="sub_title">Products</div> -->
                </div>
            </div>
            <div class="bg_gary">
                <div class="w flex-row flex-wrap">
                        <div class="products-item flex-column align-center justify-center"
                            v-for="(item, index) in productsData">
                            <img :src="http.ipAddress+item.filePath"
                                style="width: 300px;height: 300px;" alt="" @click="pageproduct(item.productType,item.id)">
                            <div class="item-name">{{ item.productNameEN }}</div>
                        </div>
                    </div>

                    <div class="flex-row justify-center" style="padding: 30px 0;">
                        <div class="more" @click="page('products')">
                            >> More
                        </div>
                    </div>
                
            </div>
        </div>
        <!-- 客户价值 -->
        <div>
            <div class="">
                <div class="flex-column align-center justify-center header1">
                    <div class="title">
                        Customer Value
                    </div>
                    <!-- <div class="sub_title">Customer Value</div> -->
                </div>
                <div class="w">
                    <div class="flex-row flex-wrap">
                        <div class="customer-item flex-column align-center justify-center" v-for="item in customersData">
                            <div class="customer-tag flex-column align-center justify-center">
                                <div>{{item.name}}</div>
                                <div style="margin-top: 5px;"><div>{{item.sub_name}}</div></div>
                            </div>
                            <div class="customer-name"><div>{{item.desc}}</div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 成功案例 -->
        <div class="">
            <div class="w">
                <div class="flex-column align-center justify-center header1">
                    <div class="title">
                        Cases
                    </div>
                    <!-- <div class="sub_title">Cases</div> -->
                </div>
            </div>
            <div class="bg_gary">
                <div class="w">
                    <div class="flex-row flex-wrap">
                        <!-- <div @click="page('cases')" class="cases-item flex-column align-center justify-center"
                            v-for="(item, index) in 8" style="border: none;"> -->
                            <!-- <img src="@/assets/img/customers_logo/网页设计-02.png" style="width: 100%;height: 100%;" alt=""> -->
                            <!-- <img :src="require('../../assets/img/customers_logo/客户logo1-0' + (index + 1) + '.png')" style="width: 200px;height: 100px;" alt=""> -->
                            <div @click="page('cases')" class="cases-item flex-column align-center justify-center"
                            v-for="(item, index) in customerData" style="border: none;">

                            <img :src="http.ipAddress+item.filePath"
                                style="width: 200px;height: 100px;" alt="">
                        </div>
                    </div>

                    <div class="flex-row justify-center" style="padding-bottom: 30px;">
                        <div class="more" @click="page('cases')">
                            >> More
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 项目咨询 -->
        <div>
            <div class="">
                <div class="flex-column align-center justify-center header1">
                    <div class="title">
                        Project consulting
                    </div>
                    <!-- <div class="sub_title">Project consulting</div> -->
                </div>
                <div class="w">
                    <div class="flex-row flex-wrap">
                        <div class="project-item flex-row align-center" v-for="item in projectData" style="justify-content: flex-end;">
                            <div style="margin-right: 10px;" class="input-name">{{item.name}}</div>
                            <div>
                                <el-input placeholder="Please enter content" @blur="judgeEmpty(item)" :class="{inputEmpty:item.error}" v-model="item.value" clearable>
                                    </el-input>
                                    <div v-if="item.name == 'Phone' && !item.validPhone" class="error-tip">The phone format is incorrect.</div>
                                    <div v-if="item.name == 'Mail' && !item.checkEmail" class="error-tip">The mailbox format is incorrect.</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row justify-center" style="padding-bottom: 30px;">
                        <div class="flex-row justify-end" style="padding-bottom: 30px;">
                            <!-- <a href="mailto:salse@fjctrl.com?subject=项目咨询&body=公司:xxx;行业：xxx;" class="btn">提交</a> -->
                            <div @click="projectSubmit()" class="btn">submit</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
// import { controllerData} from "../products/products";
export default {
    data() {
        return {
            value:"",
            swiperList: [
            {
                img: require("@/assets/img/banner-en-1.jpg"),
                path: "",
                title: '',
                content: '',
            },{
                img: require("@/assets/img/banner-en-2.jpg"),
                path: "",
                title: '',
                content: '',
            },
            ],
            productsData:[
                {
                    name:"FJ-D1 series electric vehicle control system",
                    img:"D1.png",
                    path:"",
                    switch:1,
                    index:"0"
                },{
                    name:"FJ-G1 series electric vehicle control system",
                    img:"G1.png",
                    path:"",
                    switch:1,
                    index:"1"
                },{
                    name:"FJ-S1X series electric vehicle control system",
                    img:"S1X.png",
                    path:"",
                    switch:1,
                    index:"5"
                },{
                    name:"FJ-S1 series electric vehicle control system",
                    img:"S1.png",
                    path:"",
                    switch:1,
                    index:"6"
                },{
                    name:"FJ-S0 series electric vehicle control system",
                    img:"S0.png",
                    path:"",
                    switch:1,
                    index:"3"
                },{
                    name:"FJ-M2 smart display",
                    img:"M2.png",
                    path:"",
                    switch:2,
                    index:"2"
                },
            ],
            customersData: [
                {
                    name: "Rapidly",
                    // sub_name: "Rapidly",
                    img: "S1X.png",
                    path: "",
                    desc: 'Rapidly respond to customer demand'
                },
                {
                    name:"Quality",
                    // sub_name:"Quality",
                    img:"S1X.png",
                    path:"",
                    desc:'Safe and high-quality products, and efficient productions'
                },
                {
                    name:"Advanced",
                    // sub_name:"Advanced",
                    img:"S1X.png",
                    path:"",
                    desc:'Advanced technology and testing capabilities'
                }
            ],
            projectData:[
                {
                    name:'Company',
                    value:"",
                    error:false
                },
                {
                    name:'Industry',
                    value:"",
                    error:false
                },
                {
                    name:'Name',
                    value:"",
                    error:false
                },
                {
                    name:'Phone',
                    value:"",
                    error:false,
                    validPhone: true
                },
                {
                    name:'Mail',
                    value:"",
                    error:false,
                    checkEmail: true
                },
                {
                    name:'Position',
                    value:"",
                    error:false
                }
            ],
            customerData:[]
        }
    },
    methods: {
        page(url) {
            this.$router.push('/' + url);
            debugger
            
            this.$emit("fatherRedirect",url);
        },
        pageproduct(type,index) {
            debugger
            this.$router.push({path:'/productsDetail', query: {switch:type,index}});
        },
        judgeEmpty(item){
            debugger


            if (item.name === 'Phone') {
        const re = /^(\+\d{1,4})?(\d{8,11})$/;
        item.validPhone = re.test(item.value);
      } else if (item.name === 'Mail') {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        item.checkEmail = re.test(item.value);
      }
      item.error = item.value === "";

            if (item.value == "") {
        item.error = true;
    } else {
        item.error = false;
        if (item.name == "Mail") {
            let regExp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            item.checkEmail = regExp.test(item.value);
        }
    }

            if(item.value==null||item.value==""){
                item.error=true;
            }else{
                item.error=false;
            }
        },

        projectSubmit(){
            debugger

            for (let item of this.projectData) {
                this.judgeEmpty(item);}


            let projectConsult={};

            let checkResult=true;

            this.projectData.forEach(item => {
                if(item.value==null||item.value==""){
                    item.error=true;
                    checkResult=false;
                }else{
                    item.error=false;
                }
            });

            if(!checkResult){
                return false;
            }

            projectConsult.company=this.projectData[0].value;
            projectConsult.industry=this.projectData[1].value;
            projectConsult.name=this.projectData[2].value;
            projectConsult.telephone=this.projectData[3].value;
            projectConsult.mail=this.projectData[4].value;
            projectConsult.position=this.projectData[5].value;
            projectConsult.enable=0;
            projectConsult.creator="guangwang";
            let that=this;
            this.http.post("/api/FJ_ProjectConsult/AddProjectConsult",JSON.stringify(projectConsult)).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){

            
                this.$confirm('提交成功' , '提示' , {
                    confirmButtonText:'确认',
                    type:'warning',
                    showCancelButton: false
                    // 重要，设置为true才会把右上角X和取消区分开来            
                    // closeOnClickModal: false
                }).then(()=>{
                    this.projectData[0].value="";
                    this.projectData[1].value="";
                    this.projectData[2].value="";
                    this.projectData[3].value="";
                    this.projectData[4].value="";
                    this.projectData[5].value="";
                })
               
            }
            else{
                that.$message({
                title:'失败',
                message:'...失败',
                type:'fail',
                duration:2000
            })
            }
        });

            // window.open("mailto:sales@fjctrl.com?subject=项目咨询&body=公司:"+this.projectData[0].value+";行业:"+this.projectData[1].value+";姓名:"+this.projectData[2].value+";电话:"+this.projectData[3].value+";职位:"+this.projectData[5].value);
           // window.open("mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+emailBody);

        }
        // page1(index) {
        //     this.$router.push({path:'/productsDetail', query: {switch:2,index}});
        // }
    },
    mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });

    let that=this;
        this.http.post("/api/FJ_ProductInfo/GetHomePageProduct",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.productsData=objResult.data;
            }
        });
        this.http.post("/api/FJ_Customer/GetHomePageCustomer",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.customerData=objResult.data;
            }
        });
    
    
    // /* wowjs动画 */
    // var wow = new WOW({
    //   boxClass: 'wow',
    //   animateClass: 'animated',
    //   offset: 0,
    //   mobile: true,
    //   live: true
    // })
    // wow.init();
  }
}
</script>

<style scoped>

.inputEmpty{
    border:1px solid red;
}

/* 轮播图 */
#swiper {
  /* height: 600px; */
  
  
  
}
#swiper .banner-swiper {
  width: 100%;
  /* height: 100%; */
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  /* height: 100%; */
  text-align: center;
  /* margin-left: 10%; */
  
}
#swiper .banner-swiper .swiper-slide{
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background:#0AA00A ;
  /* background: rgba(51, 51, 51, 0.534); */
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1{
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p{
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}


#swiper .swiper-button-prev  {
    color:#0AA00A ;
}

#swiper  .swiper-button-next {
    color:#0AA00A ;
}

#swiper .swiper-pagination{
    color:#0AA00A ;
}

/* .input-name::after {
    content: '* ';
    color: red;
} */

.products-item {
    width: 33.3%;
    padding: 0px;
    box-sizing: border-box;
    border: 1px solid transparent;
}

.products-item:hover {
    border: 1px solid #0AA00A;
}

.customer-item {
    width: 33.3%;
    padding: 30px;
    box-sizing: border-box;
}

.customer-tag {
    width: 200px;
    color: #0AA00A;
    border: 1px solid #0AA00A;
    border-radius: 10px;
    padding: 15px 0;
}

.customer-name {
    margin-top: 15px;
    color: #999;
}

.project-item {
    width: 30%;
    margin-bottom: 30px;
}

.cases-item {
    width: 25%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid transparent;
}
.cases-item img {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 200px;
}


.input {
    border-radius: 10px;
    padding: 5px;
}

.btn {
    background-color: #0AA00A;
    color: #fff;
    border-radius: 10px;
    padding: 5px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue